import React, { useEffect, useContext, useReducer } from 'react';
import reducer from '../reducers/invoice_reducer';
import {
  ADD_TO_INVOICE,
  CLEAR_INVOICE,
  COUNT_INVOICE_TOTALS,
  REMOVE_INVOICE_ITEM,
  TOGGLE_INVOICE_ITEM_AMOUNT
} from '../actions';

const getLocalStorage = () => {
  const invoice = sessionStorage.getItem('invoice');
  if (invoice) {
    return JSON.parse(sessionStorage.getItem('invoice'));
  }
  return [];
};

const invoiceDetail = {
  invoiceDetailID: 0,
  invoiceID: 0,
  productID: 0,
  selling_Price: 0,
  quantity: 0,
  tax_Item: 0,
  vat: 0,
  print: '',
  expiryDate: '',
  instLine1: '',
  instLine2: '',
  instLine3: '',
  instLine4: '',
  instLine5: '',
  descLine1: '',
  repeat: 0,
  toFollow: 0,
  repFrequency: 0
};

const initialState = {
  invoice: [],
  totalItems: 0,
  totalAmount: 0,
  shippingFee: 0,
  currentInvoice: invoiceDetail
};

const InvoiceContext = React.createContext();

export const InvoiceProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const addToInvoice = (productID, productName, units, sellingPrice, total) => {
    dispatch({
      type: ADD_TO_INVOICE,
      payload: { productID, productName, units, sellingPrice, total }
    });
  };

  const removeItem = (id) => {
    dispatch({ type: REMOVE_INVOICE_ITEM, payload: id });
  };

  const toggleAmount = (id, value) => {
    dispatch({ type: TOGGLE_INVOICE_ITEM_AMOUNT, payload: { id, value } });
  };

  const clearInvoice = () => {
    dispatch({ type: CLEAR_INVOICE });
  };

  useEffect(() => {
    dispatch({ type: COUNT_INVOICE_TOTALS });
    // getFirebaseStorage();
  }, [state.invoice]);

  return (
    <InvoiceContext.Provider
      value={{ ...state, addToInvoice, removeItem, toggleAmount, clearInvoice }}
    >
      {children}
    </InvoiceContext.Provider>
  );
};

export const useInvoiceContext = () => useContext(InvoiceContext);
